/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SectionAnswerDto } from './SectionAnswerDto';
import {
    SectionAnswerDtoFromJSON,
    SectionAnswerDtoFromJSONTyped,
    SectionAnswerDtoToJSON,
} from './SectionAnswerDto';

/**
 * 
 * @export
 * @interface InspectionResultResponse
 */
export interface InspectionResultResponse {
    /**
     * 
     * @type {string}
     * @memberof InspectionResultResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionResultResponse
     */
    formInstanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionResultResponse
     */
    snapshotId?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionResultResponse
     */
    machineId?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionResultResponse
     */
    machinePartId?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionResultResponse
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionResultResponse
     */
    operatorId?: string;
    /**
     * 
     * @type {Date}
     * @memberof InspectionResultResponse
     */
    completedAt?: Date;
    /**
     * 
     * @type {Array<SectionAnswerDto>}
     * @memberof InspectionResultResponse
     */
    answers?: Array<SectionAnswerDto>;
    /**
     * 
     * @type {Date}
     * @memberof InspectionResultResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InspectionResultResponse
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the InspectionResultResponse interface.
 */
export function instanceOfInspectionResultResponse(value: object): value is InspectionResultResponse {
    return true;
}

export function InspectionResultResponseFromJSON(json: any): InspectionResultResponse {
    return InspectionResultResponseFromJSONTyped(json, false);
}

export function InspectionResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'formInstanceId': json['formInstanceId'] == null ? undefined : json['formInstanceId'],
        'snapshotId': json['snapshotId'] == null ? undefined : json['snapshotId'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'machinePartId': json['machinePartId'] == null ? undefined : json['machinePartId'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'operatorId': json['operatorId'] == null ? undefined : json['operatorId'],
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'answers': json['answers'] == null ? undefined : ((json['answers'] as Array<any>).map(SectionAnswerDtoFromJSON)),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
    };
}

export function InspectionResultResponseToJSON(value?: InspectionResultResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'formInstanceId': value['formInstanceId'],
        'snapshotId': value['snapshotId'],
        'machineId': value['machineId'],
        'machinePartId': value['machinePartId'],
        'categoryId': value['categoryId'],
        'operatorId': value['operatorId'],
        'completedAt': value['completedAt'] == null ? undefined : ((value['completedAt']).toISOString()),
        'answers': value['answers'] == null ? undefined : ((value['answers'] as Array<any>).map(SectionAnswerDtoToJSON)),
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
    };
}

